import {
  ArrowPathIcon,
  ClipboardDocumentIcon,
  PhotoIcon,
} from "@heroicons/react/24/outline";
import { useState } from "react";
import { useContentActions } from "../../../hooks/ContentActionsContext";
import { SubmitButton } from "../buttons/submit-button";
import { Modal } from "../modal";
import TamaguiInput from "../tamagui-input";
import { Typography } from "../typography";

interface UpdateImageModalProps {
  src: string;
  isOpen: boolean;
  onClose: () => void;
}

export const UpdateImageModal = ({
  src,
  isOpen,
  onClose,
}: UpdateImageModalProps) => {
  const [input, setInput] = useState("");

  const { refresh } = useContentActions();

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Update Image">
      <div className="flex flex-col gap-4 w-96">
        <TamaguiInput
          id="imageUpdate"
          label="New image prompt"
          value={input}
          onChangeText={setInput}
          placeholder="Enter new image prompt"
          fullWidth
        />
        <div className="flex flex-col gap-2">
          <div className="flex flex-row gap-2 justify-center">
            <SubmitButton
              onClick={() => {
                refresh({ url: src ?? "", prompt: input, newImage: false });
                onClose();
                setInput("");
              }}
              icon={<ClipboardDocumentIcon className="w-4 h-4" color="white" />}
              isDisabled={!input}
            >
              Update Image
            </SubmitButton>
            <SubmitButton
              onClick={() => {
                refresh({ url: src ?? "", prompt: input, newImage: true });
                onClose();
                setInput("");
              }}
              icon={<PhotoIcon className="w-4 h-4" color="white" />}
              isDisabled={!input}
            >
              New Image
            </SubmitButton>
          </div>
          <Typography variant="body1" className="text-center">
            or
          </Typography>
          <SubmitButton
            onClick={() => {
              refresh({ url: src ?? "", prompt: "", newImage: false });
              onClose();
              setInput("");
            }}
            isDisabled={input !== ""}
            icon={<ArrowPathIcon className="w-4 h-4" color="white" />}
          >
            Use default prompt
          </SubmitButton>
        </div>
      </div>
    </Modal>
  );
};
